import { authInstance } from './axios/index';


const userService = {
  // 유저 인증 (access-token 발급)
  getMyInfo: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/user/v1/my`,
      useToast: false,
    };
    return authInstance(requestOptions);
  },
  //호텔/여행사 직원 정보 수정
  putStaffInfo: (userNo, data) => {
    const requestOptions = {
      method: 'PUT',
      url: `/api/user/v1/${userNo}/hotel-travle`,
      data,
    };
    return authInstance(requestOptions);
  },
  // 회원 조회 * 회원 번호로 조회
  getUserInfoByNo: (userNo) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/user/v1/${userNo}`,
    };
    return authInstance(requestOptions);
  },
  // 사용자 알림 설정 정보 조회
  getUserPushInfoByNo: () => {
    const requestOptions = {
      method: 'GET',
      url: `/api/notification/v1/user-set/my/push-info`,
    };
    return authInstance(requestOptions);
  },
  // 사용자 알림정보 수정
  putUserPushInfoByNo: (data) => {
    const requestOptions = {
      // method: 'PUT',
      // // url: `/api/notification/v1/user-set/admin/push-info/${userNo}`,
      // url: `/api/notification/v1/user-set/my/push-info`,
      // data,
      method: 'PATCH',
      url: `/api/notification/v1/user-set/my/push-info/toggle-notice`,
    };
    return authInstance(requestOptions);
  },
  //사용자 정보 수정
  putUserInfo: (data) => {
    const requestOptions = {
      method: 'PUT',
      url: `/api/user/v1/info`,
      data,
    };
    return authInstance(requestOptions);
  },
  // CSV-02: 내 접근 호텔 목록(isActive = 지금 토큰의 작업 호텔). 다중 호텔이 꺼져 있으면 소속 호텔 1행
  getMyHotels: () => {
    const requestOptions = {
      method: 'GET',
      url: `/api/user/v1/my/hotels`,
      useToast: false,
    };
    return authInstance(requestOptions);
  },
  // CSV-02: 기본 호텔 변경(다음 로그인부터 적용)
  putMyDefaultHotel: (hotelId) => {
    const requestOptions = {
      method: 'PUT',
      url: `/api/user/v1/my/hotels/${hotelId}/default`,
    };
    return authInstance(requestOptions);
  },
};

export default userService;
